import { Mutex } from 'async-mutex';
import { useCallback } from 'react';

import { useUpdateCachedReflectionTopicCompletionStatusCallback } from '../../hooks/reflections/useUpdateCachedReflectionTopicCompletionStatusCallback';
import { useHandleWhiteboardUpdateCallback } from '../../session/messages/useHandleWhiteboardUpdateMessage';
import { DataChannelMessage, DataChannelMessageType } from '../../video-sdk';
import { useUpdateDataChannelAppStateCallback } from './useUpdateDataChannelAppStateCallback';

const handleReceivedMessageMutex = new Mutex();

/**
 * Returns a callback that handles received messages on the data track for the
 * provider
 */
export function useHandleReceivedMessageCallback() {
  const updateDataTrackState = useUpdateDataChannelAppStateCallback();
  const updateWhiteboard = useHandleWhiteboardUpdateCallback();
  const updateCachedTopicCompletionStatus = useUpdateCachedReflectionTopicCompletionStatusCallback();

  return useCallback(
    (message: DataChannelMessage) => {
      return handleReceivedMessageMutex.runExclusive(async () => {
        switch (message.type) {
          // Handles messages related to app state: consent, recording, whiteboard mode, etc.
          case DataChannelMessageType.APP_STATE:
            await updateDataTrackState(message);
            break;
          // Handles incoming whiteboard updates
          case DataChannelMessageType.WHITEBOARD_UPDATE:
            await updateWhiteboard(message);
            break;
          case DataChannelMessageType.REFLECTION_TOPIC_UPDATE:
            updateCachedTopicCompletionStatus(message.topic);
            break;
        }
      });
    },
    [updateCachedTopicCompletionStatus, updateDataTrackState, updateWhiteboard],
  );
}
